var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showType == "tag"
        ? _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.showSelectDialog },
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _c(
                "div",
                { staticClass: "mt10", staticStyle: { "min-height": "40px" } },
                _vm._l(_vm.withoutList, function (wtag) {
                  return _c(
                    "el-tag",
                    {
                      key: wtag.id,
                      attrs: { closable: !_vm.disabled },
                      on: {
                        close: function ($event) {
                          return _vm.handTagClose(wtag)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(wtag.nameCn) + " ")]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm.showType == "table"
        ? _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-plus",
                  },
                  on: { click: _vm.showSelectDialog },
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _c(
                "div",
                { staticClass: "mt10", staticStyle: { "min-height": "40px" } },
                [
                  _c(
                    "vxe-table",
                    {
                      ref: "xTree",
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.withoutList,
                        border: "",
                        "row-config": { useKey: "id", keyField: "id" },
                      },
                    },
                    [
                      _c("vxe-column", {
                        attrs: {
                          type: "seq",
                          width: "60",
                          title: "序号",
                          align: "center",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "nameCn",
                          align: "center",
                          title: "中文名称",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "nameEn",
                          align: "center",
                          title: "英文名称",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "defaultValue.nameEn",
                          align: "center",
                          title: "默认值",
                        },
                      }),
                      _c("vxe-column", {
                        attrs: {
                          field: "contentLis",
                          width: "80",
                          align: "center",
                          title: "涉及内容",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (ref) {
                              var row = ref.row
                              return [
                                row.contentLis && row.contentLis.length > 0
                                  ? _c("PopoverTipList", {
                                      attrs: {
                                        labelValue: "id",
                                        tableType: "length",
                                        tableHeight: "500px",
                                        boxWidth: "400",
                                        imageDisabled: true,
                                        columns: [
                                          {
                                            prop: "nameCn",
                                            label: "中文名称",
                                          },
                                          {
                                            prop: "nameEn",
                                            label: "英文名称",
                                          },
                                        ],
                                        selectArray: row.contentLis,
                                      },
                                    })
                                  : _c("span", [_vm._v("-")]),
                              ]
                            },
                          },
                        ]),
                      }),
                      _c("vxe-column", {
                        attrs: { align: "center", title: "操作", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "text", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handTagClose(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: { click: _vm.showSelectDialog },
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
            ],
            1
          ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          staticClass: "gridDialog",
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            "destroy-on-close": false,
            "append-to-body": true,
            width: "80%",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-row",
            { staticStyle: { "margin-right": "0" }, attrs: { gutter: 15 } },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchForm",
                      staticClass: "query-form",
                      attrs: { size: "small", inline: true },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.refreshList()
                        },
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                    },
                    [
                      _vm._l(_vm.searchs, function (search, index) {
                        return _c(
                          "el-form-item",
                          { key: index, attrs: { prop: search.prop } },
                          [
                            _c("el-input", {
                              attrs: {
                                size: "small",
                                placeholder: search.label,
                                clearable: "",
                              },
                              model: {
                                value: _vm.searchForms[index],
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForms, index, $$v)
                                },
                                expression: "searchForms[index]",
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "primary",
                                size: "small",
                                icon: "el-icon-search",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.refreshList()
                                },
                              },
                            },
                            [_vm._v("查询")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                size: "small",
                                icon: "el-icon-refresh-right",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.resetSearch()
                                },
                              },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c("el-col", { attrs: { span: 14 } }, [
                _vm.showType != "tree"
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-table",
                          {
                            directives: [
                              {
                                name: "loading",
                                rawName: "v-loading",
                                value: _vm.loading,
                                expression: "loading",
                              },
                            ],
                            ref: "gridTable",
                            staticStyle: { width: "100%" },
                            attrs: {
                              data: _vm.dataList,
                              size: "small",
                              "max-height": 600,
                              border: "",
                            },
                            on: {
                              "selection-change": _vm.selectionChangeHandle,
                              "sort-change": _vm.sortChangeHandle,
                            },
                          },
                          [
                            _vm.limit <= 1
                              ? _c("el-table-column", {
                                  attrs: {
                                    "header-align": "center",
                                    align: "center",
                                    width: "50",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            _c(
                                              "el-radio",
                                              {
                                                attrs: {
                                                  label: scope.row.id,
                                                  value:
                                                    _vm
                                                      .dataListAllSelections[0] &&
                                                    _vm.dataListAllSelections[0]
                                                      .id,
                                                },
                                                nativeOn: {
                                                  change: function ($event) {
                                                    return _vm.getTemplateRow(
                                                      scope.$index,
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [_c("span")]
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3937999144
                                  ),
                                })
                              : _vm._e(),
                            _vm.limit > 1
                              ? _c("el-table-column", {
                                  attrs: {
                                    type: "selection",
                                    "header-align": "center",
                                    align: "center",
                                    width: "50",
                                  },
                                })
                              : _vm._e(),
                            _vm._l(_vm.columns, function (column, index) {
                              return [
                                _c("el-table-column", {
                                  key: index,
                                  attrs: {
                                    prop: column.prop,
                                    "header-align": "center",
                                    align: "center",
                                    "min-width": column.width
                                      ? column.width
                                      : 100,
                                    label: column.label,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function (scope) {
                                          return [
                                            column.prop == "image"
                                              ? [
                                                  scope.row.picJsonList.length >
                                                  0
                                                    ? _c("popoverTipList", {
                                                        ref: "myPopoverTipList",
                                                        refInFor: true,
                                                        attrs: {
                                                          popoverTrigger:
                                                            "hover",
                                                          labelValue: "id",
                                                          tableType: "length",
                                                          tableHeight: "500px",
                                                          boxWidth: "200",
                                                          imageDisabled: true,
                                                          columns: [],
                                                          selectArray:
                                                            scope.row
                                                              .picJsonList,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ]
                                              : [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        scope.row[column.prop]
                                                      ) +
                                                      " "
                                                  ),
                                                ],
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ]
                            }),
                          ],
                          2
                        ),
                        _vm.showPagination
                          ? _c("el-pagination", {
                              attrs: {
                                "current-page": _vm.pageNo,
                                "page-sizes": [5, 10, 50, 100],
                                "page-size": _vm.pageSize,
                                total: _vm.total,
                                layout:
                                  "total, sizes, prev, pager, next, jumper",
                              },
                              on: {
                                "size-change": _vm.sizeChangeHandle,
                                "current-change": _vm.currentChangeHandle,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticClass: "jp-common-el-tree-scrollbar el-scrollbar",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "el-scrollbar__wrap",
                            style: { height: 500 + "px", marginTop: "20px" },
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "el-scrollbar__view" },
                              [
                                _c(
                                  "vxe-table",
                                  {
                                    ref: "xTree",
                                    attrs: {
                                      "show-overflow": "",
                                      loading: _vm.loading,
                                      "tree-config": {
                                        transform: true,
                                        rowField: "id",
                                        parentField: "parentId",
                                        expandAll: true,
                                        reserve: false,
                                      },
                                      "radio-config": { labelField: "nameCn" },
                                      "row-config": {
                                        keyField: "id",
                                        isCurrent: true,
                                        isHover: true,
                                      },
                                      "checkbox-config": {
                                        labelField: "id",
                                        highlight: true,
                                        checkRowKeys: _vm.checkRowKeys,
                                        reserve: true,
                                      },
                                      data: _vm.dataList,
                                    },
                                    on: {
                                      "checkbox-change": _vm.selectChangeEvent,
                                    },
                                  },
                                  [
                                    _c("vxe-column", {
                                      attrs: {
                                        type: "checkbox",
                                        title: "全选",
                                        width: "120",
                                        "tree-node": "",
                                      },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return undefined
                                          },
                                        },
                                      ]),
                                    }),
                                    _c("vxe-column", {
                                      attrs: { field: "nameCn", title: "名称" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.nameCn) +
                                                      "（" +
                                                      _vm._s(scope.row.count) +
                                                      "）"
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]
                    ),
              ]),
              _c("el-col", { attrs: { span: 10 } }, [
                _c(
                  "div",
                  { staticClass: "rightTagbox" },
                  _vm._l(_vm.dataListAllSelections, function (tag) {
                    return _c(
                      "el-tag",
                      {
                        key: tag.id,
                        staticStyle: {
                          "margin-left": "7px",
                          "margin-bottom": "7px",
                        },
                        attrs: { closable: "", "disable-transitions": false },
                        on: {
                          close: function ($event) {
                            return _vm.del(tag)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(tag[_vm.labelName]) + " ")]
                    )
                  }),
                  1
                ),
              ]),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-circle-close" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    size: "small",
                    type: "primary",
                    icon: "el-icon-circle-check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.doSubmit()
                    },
                  },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }